module.exports = __webpack_public_path__ + "static/media/WorkSans_Light.2ab951f3.woff2";